// extracted by mini-css-extract-plugin
export default {"minimap-section":"Section_minimap-section__onCVY","section-template-image":"Section_section-template-image__Ypohf"};